import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgProgress } from 'ngx-progressbar';
import { MyAccountService } from '../../../services/myAccount.service';
import { FormGroup, FormBuilder, FormControl, Validators} from '@angular/forms';
import { CommonService } from '../../../services';
import { UserInfoViewModel, UsersViewModel, ActiveUserViewModel } from '../../../models/account-ledger.model';
import { ApiResponse } from '../../../models/api-response.model';
import { NgProgressService } from '../../../services/ngProgress.service';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})
export class AddUserComponent implements OnInit {

  title = 'New User Details';
  managePageTitle = 'Manage Existing Users';
  loadContent = false;
  isValidPassword = false;
  isPasswordMatch = false;
  newPassword = '';
  setFullWindow = false;
  hide = true;
  hideConfirm = true;
  adminChecked = false;
  purchaseChecked = false;
  userFormGroup: FormGroup;
  userInfo: UserInfoViewModel;
  // usersList: ActiveUserViewModel[];
  // usersListFilter: ActiveUserViewModel[];
  filterText: string;
  displayedColumns: string[] = ['loginname', 'accesslevel', 'button'];
  user_validation_messages: any = {
    'loginName': [
      { class: 'loginNameValidate', message: 'Please enter login name' }
    ],
    'firstName': [
      { class: 'firstNameValidate', message: 'Please enter first name' }
    ],
    'lastName': [
      { class: 'lastNameValidate', message: 'Please enter last name' }
    ],
    'email': [
      { class: 'emailValidate', message: 'Please enter email' }
    ],
    // 'password': [
    //   { class: 'passwordValidate', message: 'Please enter password' }
    // ],
    // 'confirmPassword': [
    //   { class: 'confirmPasswordValidate', message: 'Please enter confirm password' }
    // ]
  };

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private ngProgress: NgProgressService,
    private myAccountService: MyAccountService,
    private formBuilder: FormBuilder,
    private commonService: CommonService
  ) {
    this.userFormGroup = this.formBuilder.group({
      userGroup: this.getUserGroup()
    });
  }

  ngOnInit() {

    this.ngProgress.start();
    // $(".page-contents").animate({ scrollbottom: $("#levelOne").width() }, 400);
    $('#levelOne').animate({ scrollLeft: $('#manageUsers').width() + $('.child-sidebar').width() }, 400);
    this.ngProgress.done();
    // this.myAccountService.GetUsers().subscribe((res: UsersViewModel) => {
    //   if (res && res.activeUsers.length) {
    //     this.usersList = res.activeUsers;
    //     this.usersListFilter = this.usersList;
    //     // console.info(this.usersListFilter);
    //   }

    // },
    //   (error: any) => {
    //     console.error(error);
    //     this.ngProgress.done();
    //   });

  }

  saveUser(): void {
    this.ngProgress.start();
    if (this.userFormGroup.get('userGroup').valid && this.isValidPassword && this.isPasswordMatch) {
      this.userInfo = {
        loginName: this.userFormGroup.get('userGroup.loginName').value,
        accountId: '',
        firstName: this.userFormGroup.get('userGroup.firstName').value,
        lastName: this.userFormGroup.get('userGroup.lastName').value,
        email: this.userFormGroup.get('userGroup.email').value,
        password: this.newPassword,
        roles: '',
        mfaEnabled: '',
        isAdmin: this.adminChecked,
        isPurchaseOfficer: this.purchaseChecked,
        promotions: false,
        dataFeed: false,
        stockCatalogue: false,
        invoices: false,
        orderConfs: false,
        orderStatusUpdates: false,
        etaUpdates: false,
        annuityExpireUpdates: false,
        shippingReports: false,
        statements: false
      };
      this.myAccountService.CreateNewUser(this.userInfo).subscribe((res: ApiResponse) => {
        if (res.status) {
          this.commonService.showSuccess('.saveuser', res.responseMessage, 'right');
          setTimeout(() => {
            this.router.navigateByUrl('/myAccount/users?refresh=true');
          }, 2000);
        } else {
          this.commonService.showValidator('.saveuser', res.responseMessage, 'right', 'error');
        }
        this.ngProgress.done();
      },
        (error: any) => {
          console.error(error);
          this.ngProgress.done();
        });
    } else {
      this.isNotValidField('userGroup.loginName', this.user_validation_messages.loginName);
      this.isNotValidField('userGroup.firstName', this.user_validation_messages.firstName);
      this.isNotValidField('userGroup.lastName', this.user_validation_messages.lastName);
      this.isNotValidField('userGroup.email', this.user_validation_messages.email);
      // this.isNotValidField('userGroup.password', this.user_validation_messages.password);
      // this.isNotValidField('userGroup.confirmPassword', this.user_validation_messages.confirmPassword);
      this.ngProgress.done();
    }
  }

  getUserGroup(): FormGroup {
    return this.formBuilder.group({
      loginName: new FormControl('', Validators.compose([Validators.required])),
      firstName: new FormControl('', Validators.compose([Validators.required])),
      lastName: new FormControl('', Validators.compose([Validators.required])),
      email: new FormControl('', this.commonService.emailValidatorRegex()),
      // password: new FormControl('', Validators.compose([Validators.required])),
      // confirmPassword: new FormControl('', Validators.compose([Validators.required]))
    });
  }

  isNotValidField(path: string, validation: any): void {
    if (path === 'userGroup.email') {
      if (this.userFormGroup.get(path).hasError('required')) {
        this.commonService.showValidator('.' + validation[0].class, validation[0].message, 'bottom', 'error');
      } else if (this.userFormGroup.get(path).hasError('email')) {
        this.commonService.showValidator('.' + validation[0].class, 'Please enter a valid email address', 'bottom', 'error');
      }
    } else {
      if (!this.userFormGroup.get(path).valid) {
        this.commonService.showValidator('.' + validation[0].class, validation[0].message, 'bottom', 'error');
      }
    }

    if (!this.isValidPassword) this.commonService.showValidator('.passwordValidate', 'Password does not match the patterns', 'bottom', 'error');
    if (!this.isPasswordMatch) this.commonService.showValidator('.confirmPasswordValidate', 'Password mismatch', 'bottom', 'error');
  }

  // filterUsersList(): void {
  //   this.usersListFilter = this.usersList.filter(user => user.loginName.toLowerCase().includes(this.filterText.toLowerCase()));
  // }

  manageUser(user: ActiveUserViewModel): void {
    this.myAccountService.changeUserInfo(user);
    this.router.navigate(['manage-user'], { relativeTo: this.activatedRoute.parent });
  }

  onLoading(currentLoadingStatus: boolean) {

    this.loadContent = !currentLoadingStatus;
  }

  checkIsValidPassoword(isValid: boolean) {
      this.isValidPassword = isValid;
  }

  checkIsPasswordMatch(isMatch: boolean) {
    this.isPasswordMatch = isMatch;
  }

  getNewPassword(password: string) {
    this.newPassword = password;
  }

  close() {
    $('#levelOne').animate({ scrollLeft: 0 }, 400);
    this.router.navigateByUrl('/myAccount/users');
  }

}

